export const dateFormat = 'd.M.yyyy'
export const dateTimeFormat = 'd.M.yyyy HH:mm'